module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/websocket/lib/version.js
// module id = 766
// module chunks = 0